const $ = require('jquery');
import {setElementsFromScope} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import AsnStore from "../../../stores/AsnStore";
import AddressEventBus from "../../common/AddressEventBus";
// NOTE: as much as I don't think this logic
// should not be needed and should not be here,
// I have no choice due to the fact that the
// LocationTab did not follow the
// Evented Architecture.
export default function LocationInfoForCurrentAsn(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const namespace = wizardElement.data('namespace');
  const els = {};
  self._element = $();
  
  let nameMap, elementsMap;

  self.init = function(){
    self._element = wizardElement.find(".location-tab");
    setElements();
    bindElements();
  }

  function bindElements(){
    _(els).mapObject((el, k)=>{
      el.on("change", onInputFunc(k));
    })
    AddressEventBus.addChangeListener(onAddressDataChange);
  }

  function onAddressDataChange(){
    const inputsData = collectAllDataFromInputs();
    // console.log("bulk change of inputs from address bus...");
    // console.log(inputsData);
    // debugger;
    AsnStore.updateAllObjectsAndEmit(inputsData);
  }

  function collectAllDataFromInputs(){
    const inputsData = {};
    _(nameMap).mapObject((portletInputRelatedName, k)=>{
      const input = els[k];
      const val = input.val();
      // store both generic key name, and portlet
      // specific name within the Store,
      // so we can make sure we are not breaking
      // old code

      inputsData[k] = val;
      inputsData[portletInputRelatedName] = val;
    })

    return inputsData;
  }

  function onInputFunc(nmKey){
    return function(e){
      const val = $(this).val();
      const key = nameMap[nmKey];
      AsnStore.updateAllObjectsAndEmit({[key]: val, [nmKey]: val});
    };
  }

  function setElements(){
    nameMap = {
      asnId: `${namespace}asnId`,
      facilities: `${namespace}facilities`,
      cadId: `${namespace}cadId`,
      cadLocationName: `${namespace}cadLocationName`,
      cadContactPhone: `${namespace}cadContactPhone`,
      cadContactName: `${namespace}cadContactName`,
      cadAddress1: `${namespace}cadAddress1`,
      cadAddress2: `${namespace}cadAddress2`,
      cadCountry: `${namespace}cadCountry`,
      cadCity: `${namespace}cadCity`,
      state: `${namespace}states`,
      cadZipcode: `${namespace}cadZipcode`,
      cadStateText: `${namespace}cadStateText`
    };

    elementsMap = _(nameMap).mapObject((name,k)=>{
      return `#${name}`;
    });

    setElementsFromScope(els, elementsMap, self._element);
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/LocationInfoForCurrentAsn.js